<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card v-if="signUp" class="elevation-2">
            <v-form @submit.prevent="onSignUp">
              <v-toolbar dark color="blue-grey darken-4">
                <v-toolbar-title>Sign up</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text @click="signUp = false">Login instead</v-btn>
              </v-toolbar>
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text>
                <v-text-field
                    prepend-icon="person"
                    v-model="name"
                    label="Name"
                    :rules="nameRules"
                    required
                ></v-text-field>

                <v-text-field
                    prepend-icon="email"
                    name="login"
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    type="text"
                    required>
                </v-text-field>
                <v-text-field
                    prepend-icon="lock"
                    name="password"
                    v-model="password"
                    label="Password"
                    id="password"
                    type="password"
                    required>
                </v-text-field>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :disabled="loading || email =='' || password =='' || name == ''" :loading="loading">
                  Sign up
                  <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                     </span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <v-card v-if="!signUp" class="elevation-2">
            <v-form @submit.prevent="signUserIn">
              <v-toolbar dark color="blue-grey darken-4">
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text @click="signUp = true">Sign Up</v-btn>
              </v-toolbar>
              <v-toolbar v-if="error">
                    <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-toolbar>
              <v-card-text>

                <v-text-field
                    prepend-icon="email"
                    name="login"
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    type="text"
                    required>
                </v-text-field>
                <v-text-field
                    prepend-icon="lock"
                    name="password"
                    v-model="password"
                    label="Password"
                    id="password"
                    type="password"
                    required>
                </v-text-field>
                <v-btn  :disabled="emailResetLoading" v-if="email !==''" small @click="sendPasswordResetEmail" text>

                  <div v-if="!resetEmailSent">
                    <v-progress-circular
                        v-if="emailResetLoading"
                        indeterminate
                        :size="10"
                        :width="1"
                        color="black"
                    ></v-progress-circular>
                    Forgot Password?
                  </div>
                  <div v-else>
                    <v-icon>check</v-icon>Reset Email Sent.
                  </div>
                </v-btn>
                <v-btn v-else disabled small text>
                  Forgot Password? Enter your email..
                </v-btn>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :disabled="loading || email =='' || password =='' " :loading="loading">
                  Sign in
                  <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                     </span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>

  </v-main>
</template>

<script>
import {getFunctions, httpsCallable} from "firebase/functions";

export default {
  data: () => ({
    emailResetLoading: false,
    resetEmailSent: false,
    drawer: null,
    email: '',
    password: '',
    signUp: false,
    name: '',
    nameRules: [
      v => !!v || 'Name is required'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created() {
    this.$store.dispatch('setLoading', false)
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')

        // console.log('flag in sign in')
        // let activeRoute = this.$store.getters.routingLink
        // if (activeRoute) {
        //   console.log(activeRoute)
        // }
      }
    }
  },
  methods: {
    signUserIn () {
      this.$store.dispatch('signUserIn', {password: this.password, email: this.email})
    },
    sendPasswordResetEmail () {
      this.emailResetLoading = true
      const functions = getFunctions();
      const sendEmailVerification = httpsCallable(functions, 'sendEmailVerification')

      return sendEmailVerification({email: this.email, type:'resetPassword' }) // verifyEmail or resetPassword
          .then(res => {
            if (res.data) {
              this.emailResetLoading = false
              this.resetEmailSent = true
            }
          })
          .catch(err => {
            console.log(err)
            this.emailResetLoading = false
            this.resetEmailSent = false
            this.$store.dispatch('setError', err)
          })
    },
    onSignUp () {
      let userObj = {
        password: this.password,
        email: this.email,
        name: this.name
      }
      this.$store.dispatch('onSignUp', userObj)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
